import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import TableHeading from '../../modules/DataTable/components/TableHeading';

function StatisticsBuyersHeader(props) {
    function findColumnData(name, filter) {
        if (filter) {
            return props.children.find(element => element.name === filter);
        }
        return props.children.find(element => element.name === name);
    }
    return (
        <thead>
            <tr>
                <th
                    className={classnames(
                        'ui-table__cell',
                        'table__StatisticsBuyersHeader',
                        'table__StatisticsBuyersCell',
                        'table__StatisticsBuyersCell_Expand'
                    )}
                    data-title="expand"
                />
                <TableHeading
                    onSort={props.onSort}
                    {...findColumnData(
                        props.columns[1].columnName,
                        props.columns[1].filterBy)
                    }
                    {...props.columns[1]}
                />
                <TableHeading
                    onSort={props.onSort}
                    {...findColumnData(
                        props.columns[2].columnName,
                        props.columns[2].filterBy)
                    }
                    {...props.columns[2]}
                />
                <TableHeading
                    onSort={props.onSort}
                    {...findColumnData(
                        props.columns[3].columnName,
                        props.columns[3].filterBy)
                    }
                    {...props.columns[3]}
                />
                <TableHeading
                    onSort={props.onSort}
                    {...findColumnData(
                        props.columns[4].columnName,
                        props.columns[4].filterBy)
                    }
                    {...props.columns[4]}
                />
                <TableHeading
                    onSort={props.onSort}
                    {...findColumnData(
                        props.columns[5].columnName,
                        props.columns[5].filterBy)
                    }
                    {...props.columns[5]}
                />
                <TableHeading
                    onSort={props.onSort}
                    {...findColumnData(
                        props.columns[6].columnName,
                        props.columns[6].filterBy)
                    }
                    {...props.columns[6]}
                />
                <TableHeading
                    onSort={props.onSort}
                    {...findColumnData(
                        props.columns[7].columnName,
                        props.columns[7].filterBy)
                    }
                    {...props.columns[7]}
                />
            </tr>
        </thead>
    );
}

StatisticsBuyersHeader.propTypes = {
    children: PropTypes.array,
    columns: PropTypes.array,
    sortLink: PropTypes.any,
    onSort: PropTypes.func,
    columnName: PropTypes.string,
    filterBy: PropTypes.string
};

export default StatisticsBuyersHeader;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/StatisticsBuyersHeader.js